import { Avatar } from '@affine/component';
import { useCallback } from 'react';

import * as styles from './member-item.css';
import type { VMember } from './invite-member-editor';

export const MemberItem = ({
  member,
  onSelect,
}: {
  member: VMember;
  onSelect: (item: VMember) => void;
}) => {
  const handleSelect = useCallback(() => {
    onSelect(member);
  }, [member, onSelect]);
  return (
    <div className={styles.memberItemStyle} onClick={handleSelect}>
      <div className={styles.memberContainerStyle}>
        <Avatar
          rounded={member.isTeam ? "4px" : "50%"}
          key={member.id}
          url={member.avatarUrl || ''}
          name={member.name || ''}
          size={36}
        />
        <div className={styles.memberInfoStyle}>
          <div className={styles.memberNameStyle}>{member.name}</div>
          <div className={styles.memberEmailStyle}>{member.email}</div>
        </div>
      </div>
    </div>
  );
};
